/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { findDOMNode } from "./findDOMNode.js";
import { ownerWindow } from "./ownerWindow.js";
import { canUseDOM } from "./canUseDOM.js";
/**
 * ---
 * category: utilities/DOM
 * ---
 *
 * Get the associated CSS properties and values for a
 * specified element
 * @module getCSSStyleDeclaration
 *
 * @param { Node | Window | React.ReactElement | React.Component | function } el - component or DOM node
 * @param { string | null | undefined } pseudoElt - A string specifying the pseudo-element to match. Omitted (or null ) for real elements.
 * @returns { CSSStyleDeclaration | undefined } The style declaration containing css properties and values for the element or undefined
 */
function getCSSStyleDeclaration(el, pseudoElt) {
  let style;
  if (canUseDOM) {
    const node = el && findDOMNode(el);
    if (node) {
      const window = ownerWindow(el);
      try {
        style = window ? window.getComputedStyle(node, pseudoElt) : void 0;
      } catch {
        style = void 0;
      }
    }
  }
  return style;
}
export default getCSSStyleDeclaration;
export { getCSSStyleDeclaration };